import { Box, Link, Typography, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

interface DrawerHeaderProps {
  open: boolean;
  logo?: React.ReactNode;
  logoClosed?: React.ReactNode;
  appTitle?: string;
  drawerOpen: boolean;
}

const DrawerHeader: React.FC<DrawerHeaderProps> = ({
  open,
  logo,
  logoClosed,
  appTitle,
  drawerOpen,
}) => {
  const theme = useTheme();

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          minHeight: 'auto',
          pt: 3,
          pb: 1,
          pl: open ? 2 : 0,
          pr: open ? 2 : 0,
        }}
      >
        <Link
          component={RouterLink}
          to="/"
          underline="none"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            textDecoration: 'none',
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              alignItems: drawerOpen ? 'flex-start' : 'center',
              gap: 0.5,
            }}
          >
            <Box>{open ? logo : logoClosed}</Box>
            {drawerOpen && appTitle && (
              <Typography
                variant="h6"
                sx={{
                  color:
                    theme.sidebar.appearance === 'dark'
                      ? theme.sidebar.text.secondary
                      : theme.palette.text.primary,
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                }}
              >
                {appTitle}
              </Typography>
            )}
          </Box>
        </Link>
      </Box>
      {/* <Divider
        sx={{
          height: '1px',
          borderColor: '#1789FC',
          opacity: 0.5,
          mb: 2,
        }}
      /> */}
    </>
  );
};

export default DrawerHeader;
